<div class="border-b">
    <div class="container flex items-center navigation">
        <vex-navigation-item
            *ngFor="let item of items$ | async"
            [item]="item"
        ></vex-navigation-item>
    </div>
</div>
